import { memo } from 'react';
import IframeResizer from 'iframe-resizer-react';

import { VEHICLE_WARNINGS_MFE } from './microfrontendsConfig';

type VehicleWarningsMfeProps = {
    assetId: string;
    expanded?: boolean;
};

export const VehicleWarningsMfe = memo(({ assetId, expanded }: VehicleWarningsMfeProps) => {
    return (
        <IframeResizer
            src={VEHICLE_WARNINGS_MFE.url(assetId, expanded)}
            checkOrigin={false}
            style={{
                width: '1px',
                minWidth: '100%',
                border: '0',
            }}
        />
    );
});
